module.exports = __webpack_public_path__ + "img/green_street_light.2984b780.svg";